import { render } from "./vector-map.vue?vue&type=template&id=1182caf8"
import script from "./vector-map.vue?vue&type=script&lang=js"
export * from "./vector-map.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__